import router from '@/modules/termsOfService/router'

export default {
  router,
}
